import React from 'react';
import { Button, Flex } from '@chakra-ui/react';

import { OtherSponsorship, FundingSummary } from '../../../../types';
import { Modal, InputWithConfirm, TextareaWithConfirm, CurrencyInputWithConfirm } from 'shared-components';

import { getPageStatus } from './utils';
import { StudentState } from '../../../../store/student/types';
import { t } from "i18next";

interface IProps {
  sponsorKey: string | null;
  id: string;
  fundingSummary: FundingSummary;
  saveButtonText: string;
  config: StudentState['config'];
  onSave: (data: OtherSponsorship) => void;
  onClose: () => void;
}

type IComponentProps = Partial<OtherSponsorship> & IProps;

interface IState {
  otherCategoryReason: string;
  sponsorName: string;
  amountCovered: number;

  otherCategoryReasonError: string;
  sponsorNameError: string;
  amountCoveredError: string;
}

class OtherSponsor extends React.Component<IComponentProps, IState> {
  constructor(props: IComponentProps) {
    super(props);
    this.state = {
      otherCategoryReason: props.otherDesc || '',
      sponsorName: props.otherName || '',
      amountCovered: props.sponsorshipAmount || 0,
      otherCategoryReasonError: '',
      sponsorNameError: '',
      amountCoveredError: '',
    };
  }

  onBlurOtherCategoryReason = () => {
    if (this.state.otherCategoryReason === '') {
      this.setState({
        otherCategoryReasonError: 'Please fill in your reason',
      });
    }
  };

  onFocusOtherCategoryReason = () => {
    this.setState({
      otherCategoryReasonError: '',
    });
  };

  onBlurSponsorName = () => {
    if (this.state.sponsorName === '') {
      this.setState({
        sponsorNameError: 'Please fill in a sponsor name',
      });
    }
  };

  onFocusSponsorName = () => {
    this.setState({
      sponsorNameError: '',
    });
  };

  onBlurAmountCovered = () => {
    if (this.state.amountCovered === 0) {
      this.setState({
        amountCoveredError: 'Please enter a value',
      });
    }
  };

  onFocusAmountCovered = () => {
    this.setState({
      amountCoveredError: '',
    });
  };

  otherCategoryReasonChange = (event: React.FormEvent<HTMLSelectElement>) => {
    this.setState({
      otherCategoryReason: event.currentTarget.value,
    });
  };

  onSponsorNameChange = (event: React.FormEvent<HTMLInputElement>) => {
    this.setState({
      sponsorName: event.currentTarget.value,
    });
  };

  onAmountCoveredChange = (event: React.FormEvent<HTMLInputElement>) => {
    const amountCovered = Number(event.currentTarget.value) || 0;
    this.setState({
      amountCovered,
    });
  };

  getPageStatus = () => {
    return getPageStatus({
      otherDesc: this.state.otherCategoryReason,
      otherName: this.state.sponsorName,
      sponsorshipAmount: this.state.amountCovered,
    });
  };

  onSaveRegionDetails = () => {
    this.props.onSave({
      otherDesc: this.state.otherCategoryReason,
      otherName: this.state.sponsorName,
      sponsorshipAmount: this.state.amountCovered,
    });

    this.props.onClose();
  };

  render() {
    const { complete, visible } = this.getPageStatus();

    return (
      <Modal id={this.props.id} title={t('common:provideDetailsForOtherFunding')} show={true} onClose={this.props.onClose}>
        {visible.otherDesc && (
          <TextareaWithConfirm
            id="other-sponsor"
            value={this.state.otherCategoryReason}
            label={t('common:pleaseDescribeWhyThisFundingSour')}
            inputHelperText={this.props.config.Checklist.Finances.Page1.OtherFundingDesc?.helpText}
            errorText={this.state.otherCategoryReasonError}
            onChange={this.otherCategoryReasonChange}
            onBlur={this.onBlurOtherCategoryReason}
            onFocus={this.onFocusOtherCategoryReason}
          />
        )}

        {visible.otherName && (
          <InputWithConfirm
            id="sponsor-name"
            value={this.state.sponsorName}
            label={t('common:pleaseNameThisFundingSource')}
            errorText={this.state.sponsorNameError}
            onChange={this.onSponsorNameChange}
            onBlur={this.onBlurSponsorName}
            onFocus={this.onFocusSponsorName}
          />
        )}

        {visible.sponsorshipAmount && (
          <CurrencyInputWithConfirm
            id="other-sponsor-amount"
            value={this.state.amountCovered}
            errorText={this.state.amountCoveredError}
            onChange={this.onAmountCoveredChange}
            onFocus={this.onFocusAmountCovered}
            onBlur={this.onBlurAmountCovered}
            label={t('common:whatIsTheAmountBeingCoveredInPou')}
          />
        )}

        <Flex justifyContent="end">
          <Button id={'saveButton'} isDisabled={!complete} onClick={this.onSaveRegionDetails} size="lg" variant="solid">
            {this.props.saveButtonText}
          </Button>
        </Flex>
      </Modal>
    );
  }
}

export default OtherSponsor;
